import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
} from "amazon-cognito-identity-js";
import { jwtDecode } from "jwt-decode";

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_API ||
  "http://localhost:5000";

const poolData = {
  UserPoolId: "us-east-1_9W2eh3l8D",
  ClientId: "60belo3n7dlmlhfbnvjog09l7f",
};

export const userPool = new CognitoUserPool(poolData);

const saveSessionTokens = (session) => {
  const idToken = session.getIdToken()?.getJwtToken() || null;

  
  const accessToken = session.getAccessToken()?.getJwtToken() || null;
  const refreshToken = session.getRefreshToken()?.getToken() || null;

  if (idToken) localStorage.setItem("idToken", idToken);
  if (accessToken) localStorage.setItem("accessToken", accessToken);
  if (refreshToken) localStorage.setItem("refreshToken", refreshToken);

  // залишаємо для старого коду, який ще може читати authToken
  if (idToken) localStorage.setItem("authToken", idToken);
};

const clearAuthTokens = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("idToken");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
};

// Вхід
export const signIn = (email, password) => {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: userPool });

    const authDetails = new AuthenticationDetails({
      Username: email,
      Password: password,
    });

    user.authenticateUser(authDetails, {
      onSuccess: async (session) => {
        saveSessionTokens(session);
        localStorage.removeItem("cvanto_avatar");

        try {
          const token = session.getIdToken().getJwtToken();
          const decoded = jwtDecode(token);
          const userId = decoded.sub;

          console.log("Вхід успішний. User ID:", userId);

          const accessToken = session.getAccessToken()?.getJwtToken() || null;

          await fetch(`${API_BASE}/api/account/init/${userId}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({
              email: decoded.email || null,
              phone_number: decoded.phone_number || null,
            }),
          });
        } catch (err) {
          console.error("Помилка токена:", err);
        }

        resolve(session);
      },
      mfaRequired: (challengeName, challengeParameters) => {
        console.log("MFA required:", challengeName, challengeParameters);
        resolve({ challengeName, user });
      },
      totpRequired: (challengeName, challengeParameters) => {
        console.log("TOTP required:", challengeName, challengeParameters);
        resolve({ challengeName, user });
      },
      newPasswordRequired: (userAttributes, requiredAttributes) => {
        console.warn("New password required:", userAttributes, requiredAttributes);
        reject(new Error("Потрібно оновити пароль"));
      },
      onFailure: (err) => reject(err),
    });
  });
};

export const respondToMfaChallenge = (cognitoUser, code) => {
  return new Promise((resolve, reject) => {
    if (!cognitoUser) return reject(new Error("Користувач не знайдений для MFA"));

    cognitoUser.sendMFACode(
      code,
      {
        onSuccess: (session) => {
          saveSessionTokens(session);

          try {
            const token = session.getIdToken().getJwtToken();
            const decoded = jwtDecode(token);
            console.log("MFA підтверджено. User ID:", decoded.sub);
          } catch (err) {
            console.error("Помилка токена після MFA:", err);
          }

          resolve(session);
        },
        onFailure: (err) => {
          console.error("MFA помилка:", err);
          reject(err);
        },
      },
      "SOFTWARE_TOKEN_MFA"
    );
  });
};

// Реєстрація
export const signUp = (email, phoneNumber, password) => {
  return new Promise((resolve, reject) => {
    const formattedPhone = phoneNumber.trim().startsWith("+")
      ? phoneNumber.trim()
      : `+${phoneNumber.trim()}`;

    const attributes = [
      { Name: "email", Value: email },
      { Name: "phone_number", Value: formattedPhone },
    ];

    userPool.signUp(email, password, attributes, null, (err, result) => {
      if (err) {
        console.error("Cognito помилка при реєстрації:", err);
        reject(err);
      } else {
        console.log("Код підтвердження надіслано:", email);
        localStorage.setItem("tempPassword", password);
        resolve(result.user);
      }
    });
  });
};

export const confirmSignUp = (email, code) => {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: userPool });

    user.confirmRegistration(code, true, async (err, result) => {
      if (err) return reject(err);
      console.log("Код підтверджено:", result);

      const password = localStorage.getItem("tempPassword");
      if (!password) {
        return reject(new Error("Пароль втрачено. Увійдіть вручну."));
      }

      const authDetails = new AuthenticationDetails({
        Username: email,
        Password: password,
      });

      user.authenticateUser(authDetails, {
        onSuccess: async (session) => {
          saveSessionTokens(session);
          localStorage.removeItem("cvanto_avatar");

          try {
            const token = session.getIdToken().getJwtToken();
            const decoded = jwtDecode(token);
            const userId = decoded.sub;

            console.log("Вхід після підтвердження. User ID:", userId);

            const accessToken = session.getAccessToken()?.getJwtToken() || null;

            const response = await fetch(`${API_BASE}/api/account/init/${userId}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
              },
              body: JSON.stringify({
                email: decoded.email || null,
                phone_number: decoded.phone_number || null,
              }),
            });

            const data = await response.json();
            console.log("Профіль створено після підтвердження:", data);
            localStorage.removeItem("tempPassword");
            resolve(data);
          } catch (err) {
            console.error("Помилка створення профілю:", err);
            reject(err);
          }
        },
        onFailure: (authErr) => {
          console.error("Не вдалося увійти після підтвердження:", authErr);
          localStorage.removeItem("tempPassword");
          reject(authErr);
        },
      });
    });
  });
};

// Вихід
export const signOut = (setIsLoggedIn) => {
  const user = userPool.getCurrentUser();

  if (user) user.signOut();

  clearAuthTokens();

  localStorage.removeItem("tempPassword");
  localStorage.removeItem("cvanto_avatar");

  setIsLoggedIn(false);
};

// Перевірка авторизації
export const checkAuth = () => {
  return new Promise((resolve) => {
    const user = userPool.getCurrentUser();

    if (!user) {
      clearAuthTokens();
      resolve(false);
      return;
    }

    user.getSession((err, session) => {
      if (err || !session || !session.isValid()) {
        clearAuthTokens();
        resolve(false);
        return;
      }

      saveSessionTokens(session);
      resolve(true);
    });
  });
};

// ID користувача
export const getCurrentUserId = () => {
  const token =
    localStorage.getItem("idToken") ||
    localStorage.getItem("authToken");

  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return decoded.sub || null;
  } catch (err) {
    console.error("Помилка декодування токена:", err);
    return null;
  }
};

// Access token для API
export const getAccessToken = () => {
  return new Promise((resolve) => {
    try {
      const user = userPool.getCurrentUser();

      if (!user) {
        localStorage.removeItem("accessToken");
        resolve(null);
        return;
      }

      user.getSession((err, session) => {
        if (err || !session || !session.isValid()) {
          localStorage.removeItem("accessToken");
          resolve(null);
          return;
        }

        saveSessionTokens(session);

        const token = session.getAccessToken()?.getJwtToken() || null;
        resolve(token);
      });
    } catch (err) {
      console.error("Помилка отримання access token:", err);
      resolve(null);
    }
  });
};

// Скидання пароля
export const requestPasswordReset = (email) => {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: userPool });

    user.forgotPassword({
      onSuccess: (data) => {
        console.log("Код скидання пароля надіслано:", data);
        resolve(data);
      },
      onFailure: (err) => {
        console.error("Помилка скидання пароля:", err);
        reject(err);
      },
    });
  });
};

// Підтвердження нового пароля
export const confirmPasswordReset = (email, code, newPassword) => {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: userPool });

    user.confirmPassword(code, newPassword, {
      onSuccess: () => {
        console.log("Пароль змінено");
        resolve();
      },
      onFailure: (err) => {
        console.error("Помилка зміни пароля:", err);
        reject(err);
      },
    });
  });
};

// Зміна пароля
export const changePassword = (oldPassword, newPassword) => {
  return new Promise((resolve, reject) => {
    const user = userPool.getCurrentUser();
    if (!user) return reject(new Error("Користувача не знайдено"));

    user.getSession((err, session) => {
      if (err || !session || !session.isValid()) {
        return reject(new Error("Сесія недійсна. Увійдіть повторно."));
      }

      user.changePassword(oldPassword, newPassword, (err, result) => {
        if (err) return reject(err);
        console.log("Пароль змінено:", result);
        resolve(result);
      });
    });
  });
};

// Видалення акаунта
export const deleteAccount = () => {
  return new Promise((resolve, reject) => {
    const user = userPool.getCurrentUser();
    if (!user) return reject(new Error("Користувача не знайдено"));

    user.getSession((err, session) => {
      if (err || !session || !session.isValid()) {
        return reject(new Error("Сесія недійсна. Увійдіть повторно."));
      }

      user.deleteUser((err, result) => {
        if (err) return reject(err);
        console.log("Cognito акаунт видалено:", result);
        resolve();
      });
    });
  });
};